import { render, staticRenderFns } from "./PortalSprite.vue?vue&type=template&id=4cf9e4fa"
import script from "./PortalSprite.vue?vue&type=script&lang=js"
export * from "./PortalSprite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports